<template>
  <div class="torre-de-control-wrapper">
    <div class="torre-de-control-bar">
      <label class="tc-label" for="tc-date">Fecha</label>
      <select id="tc-date" v-model="selectedDate" class="tc-select" @change="onDateChange">
        <option value="latest">Última (actual)</option>
        <option v-for="f in files" :key="f.date" :value="f.date">{{ f.date }}</option>
      </select>
      <span v-if="loading" class="tc-loading">Cargando…</span>
      <span v-else-if="error" class="tc-error">{{ error }}</span>
      <button class="tc-download" :disabled="loading" @click="downloadFull">
        Descargar Excel
      </button>
    </div>
    <iframe
      :src="iframeSrc"
      title="Torre de Control"
      class="torre-de-control-iframe"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'pm-csm-torre-de-control',
  data() {
    return {
      files: [],
      selectedDate: 'latest',
      loading: false,
      error: '',
      iframeSrc: 'about:blank',
      currentFileDate: 'latest'
    }
  },
  mounted() {
    this.loadFiles().then(() => this.loadFile('latest'))
  },
  methods: {
    api() {
      const token = localStorage.getItem('access')
      return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: { Authorization: `Bearer ${token}` }
      })
    },
    async loadFiles() {
      try {
        const { data } = await this.api().get('/api/pmcsm/torre-de-control/files/', {
          params: { type: 'lite' }
        })
        this.files = Array.isArray(data.files) ? data.files : []
      } catch (e) {
        this.error = 'No se pudo obtener la lista de archivos.'
      }
    },
    loadFile(date) {
      this.error = ''
      this.currentFileDate = date
      const api = encodeURIComponent(process.env.VUE_APP_API_URL || '')
      const query = `api=${api}&date=${encodeURIComponent(date)}&v=${Date.now()}`
      this.iframeSrc = `/pmcsm/Modulo_Web.html?${query}`
    },
    onDateChange() {
      this.loadFile(this.selectedDate)
    },
    async downloadFull() {
      const date = this.currentFileDate === 'latest' ? 'latest' : this.currentFileDate
      this.error = ''
      try {
        const res = await this.api().get('/api/pmcsm/torre-de-control/file/', {
          params: { date, type: 'full' },
          responseType: 'blob'
        })
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const fileName = date === 'latest'
          ? `programa_maestro_full_latest.xlsx`
          : `programa_maestro_full_${date}.xlsx`
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = fileName
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.error = 'No se pudo descargar el archivo.'
      }
    }
  }
}
</script>

<style scoped>
.torre-de-control-wrapper {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.torre-de-control-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #e1e6e8;
}
.tc-label {
  font-size: 11px;
  font-weight: 700;
  color: #526368;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.tc-select {
  height: 32px;
  padding: 0 8px;
  border: 1px solid #d8e1e3;
  border-radius: 6px;
  font-size: 12px;
  color: #3e5156;
  background: #fff;
  min-width: 160px;
}
.tc-loading {
  font-size: 11px;
  color: #718085;
}
.tc-error {
  font-size: 11px;
  color: #d85b5b;
}
.tc-download {
  height: 32px;
  padding: 0 12px;
  border: 1px solid #0a7f7a;
  border-radius: 6px;
  background: #0a7f7a;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.tc-download:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.torre-de-control-iframe {
  flex: 1;
  width: 100%;
  border: 0;
  display: block;
  min-height: 0;
}
</style>
